import React, { useState } from "react";
import styled from "styled-components";

//
import Tab from "./sections/tabs/Tab";
import LessonTab from "./sections/tab-items/LessonTab";
import DiscussionTab from "./sections/tab-items/DiscussionTab";

export default function Left() {
  const [tab, setTab] = useState("lesson");

  function changeTab(v) {
    setTab(v);
  }

  return (
    <StyledLeft className="lesson_info col-12 col-md-6 col-lg-5 x-h-md-100">
      <div className="lesson x-h-md-100">
        <Tab tab={tab} changeTab={changeTab} />

        <div className="lesson_content overflow-hidden x-h-md-100">
          <LessonTab tab={tab} />
          <DiscussionTab tab={tab} />
        </div>
      </div>
    </StyledLeft>
  );
}

const StyledLeft = styled.div`
  
  @media (max-width: 1690px) {
    &.lesson_info {
      padding-left: 4px;
      padding-right: 4px;
    }
  }
`;
